module.exports = __webpack_public_path__ + "images/fa-signup-bg-v2-prefooter-laptop.webp";